import { defineMessages } from 'react-intl';

export default defineMessages({
  feeContraAccount: {
    id: 'sentinel.components.transferPanel.feeContraAccount',
    defaultMessage: 'Contra Account',
  },
  feeType: {
    id: 'sentinel.components.transferPanel.feeType',
    defaultMessage: 'Fee Type',
  },
  feeAccountSideDescription: {
    id: 'sentinel.components.transferPanel.feeAccountSideDescription',
    defaultMessage: 'Account Description',
  },
  feeContraAccountSideDescription: {
    id: 'sentinel.components.transferPanel.feeContraAccountSideDescription',
    defaultMessage: 'Contra Account Description',
  },
});



// WEBPACK FOOTER //
// ./src/components/transferPanelFeesDetails/messages.js